export type TagsKey =
  | 'order'
  | 'financial'
  | 'support'
  | 'personal'
  | 'urgent'
  | 'custom';

export const TAGS_MAP: Record<TagsKey, string[]> = {
  order: [
    'create_order',
    'modify_order',
    'cancel_order',
    'order_enquiry',
    'product_enquiry',
    'delivery_enquiry',
    'stock_update',
    'negotiation',
    'discount',
  ],
  financial: [
    'payment',
    'invoice',
    'ledger',
    'return',
    'credit_note',
    'refund',
  ],
  support: ['issue', 'support_request', 'query', 'UserInquiry', 'user_inquiry'],
  personal: [],
  urgent: [],
  custom: [],
};

export const TagsIcon: Record<TagsKey, string> = {
  order: '📦',
  financial: '💰',
  support: '🛠️',
  personal: '✋',
  urgent: '🚨',
  custom: '🖌️',
};
